import { Box } from '@mui/material';
import { type FC } from 'react';

interface WaveBarProps {
  delay: number;
  color?: string;
}

export const WaveBar: FC<WaveBarProps> = ({ delay, color }) => {
  const base = color ?? 'var(--tg-theme-button-color)';
  const gradient = `linear-gradient(180deg, ${base}, color-mix(in srgb, ${base} 70%, white))`;
  return (
    <Box
      sx={{
        width: 3,
        borderRadius: 4,
        background: gradient,
        animation: 'voiceWaveBar 0.55s ease-in-out infinite alternate',
        animationDelay: `${delay}ms`,
        minHeight: 4,
        maxHeight: 36,
      }}
    />
  );
};
